import DeclarationProfile from "./declarationProfile";
export default DeclarationProfile;